export default "__VITE_ASSET__W71B1Y6k__"